import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';
import { CONTACT_CONTENT } from '../../utils/constants';
import { fadeInUp, staggerContainer, staggerItem } from '../../utils/animations';

const ContactSection = () => {
  const [form, setForm] = useState({
    name: '',
    clinic: '',
    email: '',
    phone: '',
    inquiryType: '',
    message: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic here
    alert('Thank you for your inquiry! We will get back to you soon.');
    setForm({ name: '', clinic: '', email: '', phone: '', inquiryType: '', message: '' });
  };

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-12"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <motion.p
            className="text-brand-500 font-semibold text-sm uppercase tracking-wider mb-3"
            variants={fadeInUp}
          >
            Get in Touch
          </motion.p>
          <motion.h2
            className="text-3xl sm:text-4xl text-neutral-900 leading-tight"
            style={{ fontFamily: "'Livvic', sans-serif", fontWeight: 700 }}
            variants={fadeInUp}
          >
            {CONTACT_CONTENT.heading}
          </motion.h2>
        </motion.div>

        <motion.form
          onSubmit={handleSubmit}
          className="space-y-6"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <motion.div variants={staggerItem}>
              <label className="block text-sm font-medium text-neutral-700 mb-2" style={{ fontFamily: "'Livvic', sans-serif" }}>Name</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-neutral-200 bg-neutral-50 text-neutral-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all"
                style={{ fontFamily: "'Livvic', sans-serif" }}
                placeholder="Your name"
              />
            </motion.div>
            <motion.div variants={staggerItem}>
              <label className="block text-sm font-medium text-neutral-700 mb-2" style={{ fontFamily: "'Livvic', sans-serif" }}>Clinic / Company</label>
              <input
                type="text"
                name="clinic"
                value={form.clinic}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-lg border border-neutral-200 bg-neutral-50 text-neutral-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all"
                style={{ fontFamily: "'Livvic', sans-serif" }}
                placeholder="Your clinic or company"
              />
            </motion.div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <motion.div variants={staggerItem}>
              <label className="block text-sm font-medium text-neutral-700 mb-2" style={{ fontFamily: "'Livvic', sans-serif" }}>Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-neutral-200 bg-neutral-50 text-neutral-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all"
                style={{ fontFamily: "'Livvic', sans-serif" }}
                placeholder="your@email.com"
              />
            </motion.div>
            <motion.div variants={staggerItem}>
              <label className="block text-sm font-medium text-neutral-700 mb-2" style={{ fontFamily: "'Livvic', sans-serif" }}>Phone</label>
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-lg border border-neutral-200 bg-neutral-50 text-neutral-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all"
                style={{ fontFamily: "'Livvic', sans-serif" }}
                placeholder="Your phone number"
              />
            </motion.div>
          </div>

          <motion.div variants={staggerItem}>
            <label className="block text-sm font-medium text-neutral-700 mb-2" style={{ fontFamily: "'Livvic', sans-serif" }}>Inquiry Type</label>
            <select
              name="inquiryType"
              value={form.inquiryType}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 rounded-lg border border-neutral-200 bg-neutral-50 text-neutral-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all"
              style={{ fontFamily: "'Livvic', sans-serif" }}
            >
              <option value="">Select inquiry type</option>
              {CONTACT_CONTENT.inquiryTypes.map((type, i) => (
                <option key={i} value={type}>{type}</option>
              ))}
            </select>
          </motion.div>

          <motion.div variants={staggerItem}>
            <label className="block text-sm font-medium text-neutral-700 mb-2" style={{ fontFamily: "'Livvic', sans-serif" }}>Message</label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              rows={4}
              className="w-full px-4 py-3 rounded-lg border border-neutral-200 bg-neutral-50 text-neutral-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all resize-none"
              style={{ fontFamily: "'Livvic', sans-serif" }}
              placeholder="Tell us about your needs..."
            />
          </motion.div>

          <motion.div variants={staggerItem}>
            <button
              type="submit"
              className="w-full sm:w-auto inline-flex items-center justify-center space-x-2 bg-brand-500 text-white px-8 py-3 rounded-lg font-medium hover:bg-brand-600 transition-colors shadow-lg shadow-brand-500/25"
            >
              <span>Send Message</span>
              <Send size={16} />
            </button>
          </motion.div>
        </motion.form>
      </div>
    </section>
  );
};

export default ContactSection;